module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-input-page"
  }, [(_vm.$store.state.app.onboarding.accountCategory !== 'listener') ? _c('label', {
    staticClass: "auth-label-input"
  }, [_vm._v("\n    Account type\n  ")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.app.onboarding.accountCategory !== 'listener') ? _c('v-menu', {
    staticClass: "account-type-menu pb-1",
    attrs: {
      "bottom": "",
      "left": "",
      "offset-y": "",
      "nudge-top": -5,
      "nudge-left": 0,
      "content-class": "account-menu__content"
    }
  }, [_c('v-select', {
    staticClass: "pa-0",
    class: {
      'acc-selected _filled': _vm.accountType
    },
    attrs: {
      "slot": "activator",
      "placeholder": _vm.accountType ? _vm.accountType.title : 'Select',
      "single-line": "",
      "hide-details": ""
    },
    slot: "activator"
  }), _vm._v(" "), _vm._l((_vm.accountTypes), function(type, i) {
    return _c('div', {
      key: i,
      staticClass: "account-info",
      class: [((type.id) + "-menu")],
      on: {
        "click": function($event) {
          _vm.selectedAccount(type)
        }
      }
    }, [_c('div', {
      staticClass: "_title",
      staticStyle: {
        "font-size": "16px",
        "font-weight": "600"
      }
    }, [_vm._v("\n        " + _vm._s(type.title) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "_tags"
    }, [_vm._v("\n        " + _vm._s(type.tags) + "\n      ")])])
  })], 2) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "auth-label-input"
  }, [_vm._v("Username")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "pb-2",
    attrs: {
      "type": "text",
      "placeholder": "Type username",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    class: {
      'display-flex align-center gap-8 justify-space-between': _vm.$vuetify.breakpoint.width <= 1280,
    }
  }, [(_vm.$vuetify.breakpoint.width <= 1280) ? _c('v-btn', {
    staticClass: "back-button",
    on: {
      "click": function($event) {
        _vm.$emit('actionPrevStage')
      }
    }
  }, [_vm._v("\n      Back\n    ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "auth-button",
    class: {
      _disabled: !_vm.validated('skipToast'),
      'auth-bg-disabled': _vm.checkDataEmpty,
      'auth-bg-active': !_vm.checkDataEmpty,
    },
    on: {
      "click": function($event) {
        _vm.handleNextStage()
      }
    }
  }, [_vm._v("\n      Next\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d071d58","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/auth/onboarding/accountType.vue
// module id = 1795
// module chunks = 180